export const PATHS = {
  paacapPatientReg: {
    listCoupon: '/paacap-patient-reg/list_coupon',
    listRequest: '/paacap-patient-reg/list_request',
    checkStatus: '/paacap-patient-reg/check_status',
    getPatient: '/paacap-patient-reg/get'
  }
} as const;
